import { api } from './api';

export const couponApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCoupons: builder.mutation({
      query: ({
        order,
        orderBy,
        filter,
        status,
        targetType,
        page,
        pageSize,
      }) => ({
        url: 'getCoupons',
        method: 'POST',
        body: {
          order,
          orderBy,
          filter,
          status,
          targetType,
          page,
          pageSize,
        },
      }),
    }),

    getCoupon: builder.mutation({
      query: ({ id }) => ({
        url: 'getCoupon',
        method: 'POST',
        body: { id },
      }),
    }),

    saveCoupon: builder.mutation({
      query: (couponData) => ({
        url: 'saveCoupon',
        method: 'POST',
        body: couponData,
      }),
    }),

    deleteCoupon: builder.mutation({
      query: ({ id }) => ({
        url: 'deleteCoupon',
        method: 'POST',
        body: { id },
      }),
    }),

    updateCouponStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: 'updateCouponStatus',
        method: 'POST',
        body: { id, status },
      }),
    }),

    getAvailableCoupons: builder.mutation<unknown, { customerId?: number | string } | void>({
      query: ({ customerId } = {}) => ({
        url: customerId
          ? `getAvailableCoupons?customerId=${customerId}`
          : 'getAvailableCoupons',
        method: 'GET',
      }),
    }),

    validateCoupon: builder.mutation({
      query: ({ couponCode, cartItems, customerId }) => ({
        url: 'validateCoupon',
        method: 'POST',
        body: { couponCode, cartItems, customerId },
      }),
    }),

    calculateDiscounts: builder.mutation({
      query: ({ couponCodes, cartItems, customerId }) => ({
        url: 'calculateDiscounts',
        method: 'POST',
        body: { couponCodes, cartItems, customerId },
      }),
    }),
  }),
});

export const {
  useGetCouponsMutation,
  useGetCouponMutation,
  useSaveCouponMutation,
  useDeleteCouponMutation,
  useUpdateCouponStatusMutation,
  useGetAvailableCouponsMutation,
  useValidateCouponMutation,
  useCalculateDiscountsMutation,
} = couponApi;

